import React, { Component } from 'react';
import { Button, Icon, Spin } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from "react-router";

import { actions } from "store";
import { Page, PageHeader } from 'components/layout';
import { ActionButton } from "components/common";
import { JobForm } from 'components/blocks/Job';
import JobMainScreen from './JobMainScreen';
import JobReviewListScreen from './JobReviewListScreen';


class JobDetailScreen extends Component {
  state = {
    id: null,
  };

  componentDidMount() {
    const { actions, match } = this.props;
    actions.jobDetailLoad({ id: match.params.id });
    this.setState({ id: match.params.id });
  }

  showEditForm = (item = null) => {
    const { actions } = this.props;
    actions.jobShowEditForm({ show: true, object: item });
  };

  delete = () => {
    const { actions } = this.props;
    const { id } = this.state;
    actions.jobDelete({ id });
  };

  render() {
    const { history, job } = this.props;
    const detail = job.detail || {};

    return (
      <Page>
        <Spin spinning={job.updateStatus.isLoading}>
          <PageHeader
            history={history}
            title={detail.name}
            actions={[
              <Button onClick={() => this.showEditForm(detail)}>
                <Icon type="plus"/>
                <span>Редактировать</span>
              </Button>,
              <ActionButton
                actions={[
                  {
                    key: 'delete',
                    icon: 'delete',
                    title: 'Удалить',
                    action: this.delete,
                    confirm: {
                      title: 'Уверены, что хотите удалить?',
                      okText: 'Удалить',
                      cancelText: 'Отмена'
                    }
                  },
                ]}
              />
            ]}
            basePath={`/job/${this.state.id}`}
            tabs={[
              { title: 'Детали', key: 'detail' },
              { title: 'Отзывы', key: 'reviews' },
            ]}
          />

          <Route exact path="/job/:id" component={JobMainScreen}/>
          <Route exact path="/job/:id/reviews" component={JobReviewListScreen}/>

          <JobForm/>
        </Spin>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    job: state.job,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.job), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(JobDetailScreen);
